import _regenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import router from './router';
import store from './store';
import { ElMessage } from 'element-plus';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import getPageTitle from '@/utils/get-page-title';
import roles from '@/router/roles';
import { hasAccess, nextPage } from '@/router/permission';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login-c', '/login-b', '/auth-redirect', '/azure-redirect', '/403', '/404', '/account-transfer', '/pass-reset', '/pass-update', '/environment', '/lasso/callback', '/lasso/test', '/temporarily', '/temporarily/detail', '/page-pdf']; // no redirect whitelist

if (process.env.VUE_APP_ENV !== 'production') {
  whiteList.push('/login-bb');
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var hasToken, isRouterInited, role, accessRoutes, loginUrl, _role, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = store.getters['user/token'];
          if (!hasToken) {
            _context.n = 8;
            break;
          }
          if (!(to.path === '/login-c' || to.path === '/login-b')) {
            _context.n = 1;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 7;
          break;
        case 1:
          // determine whether the user has obtained his permission roles through getInfo
          isRouterInited = store.getters['permission/addRoutes'] && store.getters['permission/addRoutes'].length > 0;
          if (!isRouterInited) {
            _context.n = 3;
            break;
          }
          if (!(to.meta && to.meta.permissionTag && !hasAccess(to.meta.permissionTag))) {
            _context.n = 2;
            break;
          }
          next({
            path: nextPage(to.meta.permissionTag)
          });
          return _context.a(2);
        case 2:
          next();
          _context.n = 7;
          break;
        case 3:
          _context.p = 3;
          // note: role must be a String! such as: 'Admin' or 'Customer' or 'Operator'
          role = store.getters['user/role'];
          if (!(role !== roles.roleCustomer)) {
            _context.n = 4;
            break;
          }
          _context.n = 4;
          return store.dispatch('user/getUserPermission');
        case 4:
          _context.n = 5;
          return store.dispatch('permission/generateRoutes', role);
        case 5:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          // router.addRoutes(accessRoutes)
          accessRoutes.forEach(function (item) {
            router.addRoute(item);
          });

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          // remove token and go to login page to re-login
          store.commit('user/SET_TOKEN', '');
          ElMessage.error(_t || 'Has Error');
          next("/login-c?redirect=".concat(to.path)); // ?redirect=${to.path}
          NProgress.done();
        case 7:
          _context.n = 11;
          break;
        case 8:
          if (!(whiteList.indexOf(to.path) !== -1 && !(to.path === '/pass-reset' && !store.getters['user/token_temp']))) {
            _context.n = 9;
            break;
          }
          // in the free login whitelist, go directly
          next();
          _context.n = 11;
          break;
        case 9:
          // other pages that do not have permission to access are redirected to the login page.
          loginUrl = '/login-c';
          _role = store.getters['user/role'];
          if (_role) {
            _context.n = 10;
            break;
          }
          next("".concat(loginUrl));
          NProgress.done();
          return _context.a(2);
        case 10:
          loginUrl = _role === roles.roleCustomer ? '/login-c' : '/login-b';
          // next(`${loginUrl}?redirect=${to.path}`)// ?redirect=${to.path}
          next({
            path: loginUrl,
            query: _objectSpread({
              redirect: to.path
            }, to.query)
          });
          NProgress.done();
        case 11:
          return _context.a(2);
      }
    }, _callee, null, [[3, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});